import { ParamsProps, ReturnType } from '@apis/types'
import request from '@utils/request'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'inquiries',
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `inquiries/${args.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { list, updateStatus }
